import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import { injectIntl, FormattedMessage, IntlShape } from 'react-intl';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { hideSnackbar, HideSnackbar } from '../snackbarReducer';

import rootReducer from '../../../rootReducer';
import Box from '../../../components/material/Box';

export interface SnackbarProps {
  open: boolean;
  message: string;
  hideSnackbar?: (reason: string) => void;
  bg: 'danger' | 'success' | 'info' | 'none';
  autoHide?: boolean;
  html?: boolean;
  values?: Record<string, any>;
  intl: IntlShape;
}

interface DispatchProps {
  hideSnackbar: HideSnackbar;
}

type State = ReturnType<typeof rootReducer>;

const CustomSnackbar: React.FC<SnackbarProps & DispatchProps> = ({autoHide = true, ...props}) => {
  const { open, hideSnackbar, bg } = props;

  const body = () => {
    const { html, message, intl, values } = props;

    if (!message) {
      return undefined;
    }

    if (html) {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage({ id: message }, values),
          }}
        />
      );
    }

    return <FormattedMessage id={message} values={values} />;
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHide ? 4000 : null}
      onClose={(event, reason) => {
        hideSnackbar?.(reason);
      }}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      style={{
        padding: 0,
        backgroundColor: '',
        top: 0,
        transform: 'translate3d(-150px, 0px, 0px)',
      }}
    >
      <Box
        className={`bg-color-${bg} snackbar`}
        body={body()}
        bodyStyle={{ paddingTop: '5px' }}
      />
    </Snackbar>
  );
};

const mapStateToProps = (state: State): SnackbarProps => ({
  open: state.snackbarReducer.open,
  message: state.snackbarReducer.message,
  bg: state.snackbarReducer.bg,
  autoHide: state.snackbarReducer.autoHide,
  html: state.snackbarReducer.html,
  values: state.snackbarReducer.values,
} as SnackbarProps);

const mapDispatchToProps = (dispatch): DispatchProps =>
  bindActionCreators({ hideSnackbar }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(CustomSnackbar));
